import React, {useState} from 'react';
import {Auth} from "../../components";
import {Button, ForwarderLink, GoogleButton, Input} from "../../core-ui";
import {signIn, signInWithGoogleAccount} from "../../helpers/auth";
import {db} from "../../services/firebase";
import {Link} from "react-router-dom";
import Notification from "../../helpers/notifications";
import {useTranslation} from "react-i18next";

const LOGIN_FORM_DATA = {
    email: '',
    password: ''
};

const Login = () => {

    const [loginForm, setLoginForm] = useState(LOGIN_FORM_DATA);
    const [t] = useTranslation();

    const changeHandler = ({target: {value, name}}) => {
        setLoginForm(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const onLogin = async () => {
        const {email, password} = loginForm;

        try {
           await signIn(email, password);
        } catch (e) {
            Notification.danger(e.message)
        }
    }

    const onSignInWithGoogle = async () => {
        try {
            const loggedUserData = await signInWithGoogleAccount();

            if (loggedUserData.additionalUserInfo.isNewUser) {
                const {uid, displayName, email, photoURL, phoneNumber} = loggedUserData.user
                await db.ref('users').push({
                    uid,
                    displayName,
                    email,
                    photoURL,
                    phoneNumber,
                    online: true
                })
            }

        } catch (e) {
            Notification.danger(e.message);
        }
    }

    return (
        <Auth>
            <h1 className='text-center mb-2 mb-xl-4'>{t('login')}</h1>
            <p className='text-center mb-0 mb-xl-3'>{t('enter info login')}</p>
            <div className='my-3 my-xl-5'>
                <Input className='w-100 mb-3 lng-text'
                       placeholder={t('email')}
                       value={loginForm.email}
                       name='email'
                       onChange={changeHandler}/>
                <Input className='w-100 mb-3 lng-text'
                       type='password'
                       placeholder={t('password')}
                       value={loginForm.password}
                       name='password'
                       onChange={changeHandler}/>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <Button varient='primary' onClick={onLogin}>
                        {t('login')}
                    </Button>
                </div>
            </div>

            <div className='text-center d-flex flex-column justify-content-end pb-3 mt-4 mt-xl-0' style={{flex: 1}}>
                <p className='mb-0 d-none d-xl-block'>{t('or')}</p>
                <p>{t('login with')}</p>
                <div className='d-flex align-items-center justify-content-between'>
                    <GoogleButton className='flex-grow-1' onClick={onSignInWithGoogle}>
                        <i className="fab fa-google text-main-danger me-2" />{t('google')}
                    </GoogleButton>
                </div>
                <Link to='/signup' className='mt-3 text-decoration-none'>
                    <ForwarderLink>{t('no account')}</ForwarderLink>
                </Link>
            </div>
        </Auth>
    );
};

export default Login;
